import { render, staticRenderFns } from "./GoogleLoginCallback.vue?vue&type=template&id=16546931&"
import script from "./GoogleLoginCallback.vue?vue&type=script&lang=js&"
export * from "./GoogleLoginCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports